exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group.select {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.form-group.select select {\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/experience-params-edit/experience-params-edit.component.css
// module id = ../../../../../src/app/experience-params-edit/experience-params-edit.component.css
// module chunks = main